import React from "react";
import { LightningIcon } from "@phosphor-icons/react";
import CustomButton from "../../shared/CustomButton/CustomButton";
import styles from "./ProfilingHubPage.module.scss";

interface AutoPRAlertCardProps {
  alert: any;
  isConfirming: boolean;
  isDiscarding: boolean;
  onConfirm: (id: string) => void;
  onDiscard: (id: string) => void;
}

const AutoPRAlertCard: React.FC<AutoPRAlertCardProps> = ({
  alert,
  isConfirming,
  isDiscarding,
  onConfirm,
  onDiscard,
}) => {
  return (
    <div className={styles.alertCard}>
      <div className={styles.alertBody}>
        <p className={styles.alertMessage}>{alert.message}</p>
        <p className={styles.alertMeta}>
          {alert.metadata?.protocolName}
          {alert.metadata?.loadActual != null && (
            <> &middot; carico {alert.metadata.loadActual} kg vs PR {alert.metadata.previousPR} kg</>
          )}
        </p>
      </div>
      <div className={styles.alertActions}>
        <CustomButton
          color="outline"
          size="sm"
          isLoading={isDiscarding}
          onClick={() => onDiscard(alert._id)}
        >
          Scarta
        </CustomButton>
        <CustomButton
          color="primary"
          size="sm"
          isLoading={isConfirming}
          onClick={() => onConfirm(alert._id)}
        >
          Conferma PR
        </CustomButton>
      </div>
    </div>
  );
};

export default AutoPRAlertCard;
